import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";
import moment from 'moment';

const LoadRoundDetails = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/Round/GetAppRounds')
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(defaultSite.id, "AppRounds");
        setTimeout(function () { offlineService.addOffline(defaultSite.id, "AppRounds", result); }, 200);
    },
    (error) => {
        console.log(error);
    });
};

const LoadRoundList = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/Round/GetRoundLists', { siteCode: defaultSite.id.toString() })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(defaultSite.id, "RoundLists");
        offlineService.addOffline(defaultSite.id, "RoundLists", result);

        for (let item of result) {
            setGeoLocationBranchRounds(defaultSite.id, date, item.name);
        }
    },
    (error) => {
        console.log(error);
    });
};

const LoadAssignedToUsers = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/Home/GetAssignedTo', {
        houseCode: defaultSite.houseCode.toString()
    })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(defaultSite.id, "AssignedTo");
        offlineService.addOffline(defaultSite.id, "AssignedTo", result);
    },
    (error) => {
        console.log(error);
    });
};

const LoadResolutions = () => {
    const offlineService = new OfflineService();

    HttpService.post('/Home/GetResolutions')
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(0, "Resolutions");
        offlineService.addOffline(0, "Resolutions", result);
    },
    (error) => {
        console.log(error);
    });
};

const LoadComments = () => {
    const offlineService = new OfflineService();

    HttpService.post('/Home/GetComments')
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(0, "Comments");
        offlineService.addOffline(0, "Comments", result);
    },
    (error) => {
        console.log(error);
    });
};

const setGeoLocationBranchRounds = (siteId, date, roundListName) => {
    const offlineService = new OfflineService();

    HttpService.post('/Round/GetGeoLocationBranchRounds', {
        Date: date,
        Site: siteId,
        RoundState: 'All',
        RoundListName: roundListName,
        UnsatisfactoryCheckBox: false,
        CompletedCheckBox: false,
        ManagerConfirmedCheckBox: false,
        Key: '',
        MaxId: -1
    })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(siteId, "GeoLocationBranchRounds-" + roundListName);
        offlineService.addOffline(siteId, "GeoLocationBranchRounds-" + roundListName, result);
    },
    (error) => {
        console.log(error);
    });
};

const SaveRoundOfflineData = async (siteId, entityId, keyName, item, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();
    let id = -1;
    let pId = -1;
    let exists = [];

    if ((entityId + "").substr(0, 1) === "$") {
        pId = parseInt(entityId.substr(1, entityId.length - 1));
        exists = await offlineSyncService.getByNameAndId(pId, keyName);
    }
    else if (entityId > 0) {
        pId = entityId;
        exists = await offlineSyncService.getByNameAndEntityId(pId, keyName);
    }

    if (!isOnline) {
        if (remove && ((entityId + "").substr(0, 1) === "$")) {
            offlineSyncService.removeById(exists.Id);
        }
        else if (entityId === 0 || !exists) {
            id = await offlineSyncService.add(siteId, pId, url, keyName, item);
        }
        else {
            offlineSyncService.updateById(exists.Id, item);
            id = exists.Id;
        }
    }

    UpdateOfflineData(siteId, item, keyName);
    return id;
};

const UpdateOfflineData = async (siteId, item, keyName) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "AppRounds");
    const data = offlineResult.OfflineData;

    if (keyName === "SaveNotesForRoundLocation") {
        for (var index = 0; index < data.length; index++) {
            if ((data[index].GeoLocationAncestorId === siteId) && (data[index].RoundListName === item.RoundListName) && (moment(data[index].RoundDate).format('L') === item.RoundDate) && (data[index].Round === parseInt(item.Round))) {
                offlineResult.OfflineData[index].Notes = item.Notes;
            }
        }
    }
    else if (keyName === "SaveAppRoundWithSAT" || keyName === "SaveAppRoundWithUNSAT") {
        let index = data.findIndex(d => d.GeoLocationAncestorId === siteId && d.GeoLocationId === item.GeoLocationId && d.RoundListName === item.RoundListName && moment(d.RoundDate).format('L') === item.RoundDate && d.Round === parseInt(item.Round));
        if (index === -1)
            offlineResult.OfflineData.push(item);
        else
            offlineResult.OfflineData[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "AppRounds", offlineResult.OfflineData);
};

export { LoadRoundDetails, LoadRoundList, LoadAssignedToUsers, LoadResolutions, LoadComments, SaveRoundOfflineData };
